import {
    Component,
    ElementRef,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
}                                       from '@angular/core';
  
export const CLOCK_HOURS = 24;
export const CLOCK_MINUTES = 60;
export const CLOCK_RADIUS = 120;
export const CLOCK_INNER_RADIUS = 66;
export const CLOCK_OUTER_RADIUS = 99;
export const CLOCK_TICK_RADIUS = 17;
  
@Component({
    selector: 'md2-clock',
    template: require('./clock.html'),
    host: {
        'role': 'clock',
        '(mousedown)': '_handleMousedown($event)',
        '(touchstart)': '_handleMousedown($event)',
    },
    encapsulation: ViewEncapsulation.None
})
export class Md2Clock {
  
    private mouseMoveListener: any;
    private mouseUpListener: any;
  
    private _time: string;
  
    _view: boolean = true;
  
    _hours: Array<Object> = [];
    _minutes: Array<Object> = [];
  
    _hour: number = 0;
    _minute: number = 0;
  
    constructor(private _element: ElementRef) {
        this.renderClock();
        this.mouseMoveListener = (event: any) => { this._handleMousemove(event); };
        this.mouseUpListener = (event: any) => { this._handleMouseup(event); };
    }
  
    @Output() timeChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() onHourChange: EventEmitter<number> = new EventEmitter<number>();
    @Output() onMinuteChange: EventEmitter<number> = new EventEmitter<number>();
  
    @Input()
    get time() { return this._time; }
    set time(value: string) {
        if (this._time !== value) {
            this._time = value || '00:00';
            this._hour = parseInt(this._time.split(':')[0]);
            this._minute = parseInt(this._time.split(':')[1]);
        }
    }
  
    @Input()
    timeRange: number = 1;
  
    @Input()
    set view(value: string) {
        if (value === 'minute') {
            this._view = false;
        } else { this._view = true; }
    }
  
    get hand(): any {
        let deg = 0;
        let radius = CLOCK_OUTER_RADIUS;
        if (this._view) {
            let inner = this._hour > 0 && this._hour < 13;
            radius = inner ? CLOCK_INNER_RADIUS : CLOCK_OUTER_RADIUS;
            deg = Math.round(this._hour * (360 / (CLOCK_HOURS / 2)));
        } else {
            deg = Math.round(this._minute * (360 / CLOCK_MINUTES));
        }
    
        return {
            'transform': `rotate(${deg}deg)`,
            'height': `${radius}px`,
            'margin-top': `${120 - radius}px`
        };
    }
  
    _action1: boolean = false;
    _action2: boolean = false;

    _handleMousedown(event: any) {
        if (this._action1 == false) {
            this._action1 = true;

            this.setTime(event);
            document.addEventListener('mousemove', this.mouseMoveListener);
            document.addEventListener('touchmove', this.mouseMoveListener);
            document.addEventListener('mouseup', this.mouseUpListener);
            document.addEventListener('touchend', this.mouseUpListener);
        }

        event.preventDefault();
    }
  
    _handleMousemove(event: any) {
        this.setTime(event);

        event.preventDefault();
    }
  
    _handleMouseup(event: any) {
        document.removeEventListener('mousemove', this.mouseMoveListener);
        document.removeEventListener('touchmove', this.mouseMoveListener);
        document.removeEventListener('mouseup', this.mouseUpListener);
        document.removeEventListener('touchend', this.mouseUpListener);

        if (this._action2 == false) {
            this._action2 = true;

            if (this._view) {
                this.onHourChange.emit(this._hour);
            } else {
                this.onMinuteChange.emit(this._minute);
            }

            setTimeout(() => {
                this._action2 = false;
            }, 0);
        }

        this._action1 = false;
    }
  
    _handleKeydown(event: KeyboardEvent) { }
  
    /** Emits an event when the user selects a time. */
    _emitChangeEvent(): void {
        this.timeChange.emit(this.time);
    }
  
    /**
     * render Click
     */
    private renderClock() {
        this._hours.length = 0;
    
        for (let i = 0; i < CLOCK_HOURS; i++) {
            let radian = i / 6 * Math.PI;
            let inner = i > 0 && i < 13,
            radius = inner ? CLOCK_INNER_RADIUS : CLOCK_OUTER_RADIUS;
            this._hours.push({
                hour: i === 0 ? '00' : i,
                top: CLOCK_RADIUS - Math.cos(radian) * radius - CLOCK_TICK_RADIUS,
                left: CLOCK_RADIUS + Math.sin(radian) * radius - CLOCK_TICK_RADIUS
            });
        }
  
        for (let i = 0; i < CLOCK_MINUTES; i += 5) {
            let radian = i / 30 * Math.PI;
            this._minutes.push({
                minute: i === 0 ? '00' : i,
                top: CLOCK_RADIUS - Math.cos(radian) * CLOCK_OUTER_RADIUS - CLOCK_TICK_RADIUS,
                left: CLOCK_RADIUS + Math.sin(radian) * CLOCK_OUTER_RADIUS - CLOCK_TICK_RADIUS
            });
        }
    }
  
    /**
     * Set Time
     * @param event
     */
    private setTime(event: any) {
        let trigger = this._element.nativeElement;
        let triggerRect = trigger.getBoundingClientRect();
        let width = trigger.offsetWidth;
        let height = trigger.offsetHeight;
        let pageX = event.pageX !== undefined ? event.pageX : event.touches[0].pageX;
        let pageY = event.pageY !== undefined ? event.pageY : event.touches[0].pageY;
        let x = (width / 2) - (pageX - triggerRect.left - window.pageXOffset);
        let y = (height / 2) - (pageY - triggerRect.top - window.pageYOffset);
        let radian = Math.atan2(-x, y);
        let unit = Math.PI / (this._view ? 6 : 30);
        let z = Math.sqrt(x * x + y * y);
        let inner = this._view && z < (CLOCK_OUTER_RADIUS + CLOCK_INNER_RADIUS) / 2;
        let value = 0;
  
        if (radian < 0) { radian = Math.PI * 2 + radian; }
        value = Math.round(radian / unit);
        radian = value * unit;
    
        if (this._view) {
            if (value === 12) { value = 0; }
            value = inner ? (value === 0 ? 12 : value) : value === 0 ? 0 : value + 12;
            this._hour = value;
        } else {
            if (value === 60) { value = 0; }
            if (this.timeRange > 0) {
                value = Math.floor(value / this.timeRange) * this.timeRange;
            }
            
            this._minute = value;
        }
        this._time = this._hour + ':' + this._minute;
        this._emitChangeEvent();
    }
  
    selectHour(h) {
        if (this._hour + h < 0) {
            this._hour = 23;
        }
        else {
            this._hour += h;
        }

        this._time = this._hour + ':' + this._minute;
        //this._emitChangeEvent();
        return false;
    }
    selectMinute(m) {
        if (this.timeRange > 0) {
            m = m * this.timeRange;
        }

        let mm = this._minute + m;
        if (mm < 0) {
            mm = 59;
        }
        else if (mm >= 60) {
            mm = 0;
        }

        if (this.timeRange > 0) {
            mm = Math.floor(mm / this.timeRange) * this.timeRange;
        }
        this._minute = mm;

        this._time = this._hour + ':' + this._minute;
        //this._emitChangeEvent();
        return false;
    }

    getMinute(idx) {
        let m = idx;
        if (this.timeRange > 0) {
            m = idx * this.timeRange;
        }

        let mm = this._minute + m;
        if (mm < 0) {
            mm = 60 + m;
        }
        else if (mm >= 60) {
            mm = mm - 60;
        }

        if (this.timeRange > 0) {
            mm = Math.floor(mm / this.timeRange) * this.timeRange;
        }
        return mm;
    }
    getHour(idx) {
        let h = this._hour + idx;
        if (h < 0) {
            h = 23;
        }
        else if (h >= 24) {
            h = h - 24;
        }

        return h;
    }
    timeFormat(t) {
        if (t < 10) {
            return "0" + t;
        }
        
        return "" + t;
    }

    onUpdateTime() {
        this._emitChangeEvent();
        this.onMinuteChange.emit(this._minute);
        return false;
    }


    minuteTouchData = {
        isStart: false,
        start: {
          position: -1,
          time: null
        },
        positions: [],
        isMove: false
    };
    minuteTouchStart(event) {
        this.minuteTouchData.isStart = true;

        let time = new Date().getTime();

        let position = event.clientY || event.touches[0].clientY;
        this.minuteTouchData.start.position = position;
        this.minuteTouchData.start.time = time;

        this.minuteTouchData.positions.push({
            position: position,
            time: time
        });
    }
    minuteTouchMove(event) {
        if (this.minuteTouchData.isStart == true) {
            let position = event.clientY || event.touches[0].clientY;
            this.minuteTouchData.positions.push({
                position: position,
                time: new Date().getTime()
            });

            if (this.minuteTouchData.isMove == false) {
                this.minuteTouchData.isMove = true;

                let loop = () => {
                    setTimeout(() => {
                        let pos = this.minuteTouchData.positions.shift();
                        if (pos != undefined) {
                            if (pos.time - this.minuteTouchData.start.time >= 30) {
                                let diff = pos.position - this.minuteTouchData.start.position;
                                if (Math.abs(diff) > 5) {
                                    let m = 1;
                                    if (diff > 0) {
                                        m = -1;
                                    }
                                    if (this.timeRange > 0) {
                                        m = m * this.timeRange;
                                    }

                                    let cm = this._minute + m;
                                    if (cm < 0) {
                                        cm = 60 + m;
                                    }
                                    else if (cm >= 60) {
                                        cm = cm - 60;
                                    }

                                    if (this.timeRange > 0) {
                                        cm = Math.floor(cm / this.timeRange) * this.timeRange;
                                    }

                                    this._minute = cm;
                                    this._time = this._hour + ':' + this._minute;
                                    //this._emitChangeEvent();

                                    this.minuteTouchData.start.position = pos.position;
                                    this.minuteTouchData.start.time = pos.time;
                                }
                            }
                            
                            loop();
                        }
                        else {
                            this.minuteTouchData.isMove = false;
                        }
                    }, 30);
                }
                loop();
            }
        }

        event.preventDefault();
    }
    minuteTouchEnd(event) {
        if (this.minuteTouchData.isStart == true) {
            this.minuteTouchData.isStart = false;
            this.minuteTouchData.start.position = -1;
            this.minuteTouchData.start.time = null;
        }
    }

    hourTouchData = {
        isStart: false,
        start: {
            position: -1,
            time: null
        },
        positions: [],
        isMove: false
    };
    hourTouchStart(event) {
        this.hourTouchData.isStart = true;

        let time = new Date().getTime();

        let position = event.clientY || event.touches[0].clientY;
        this.hourTouchData.start.position = position;
        this.hourTouchData.start.time = time;

        this.hourTouchData.positions.push({
            position: position,
            time: time
        });
    }
    hourTouchMove(event) {
        if (this.hourTouchData.isStart == true) {
            let position = event.clientY || event.touches[0].clientY;
            this.hourTouchData.positions.push({
                position: position,
                time: new Date().getTime()
            });

            if (this.hourTouchData.isMove == false) {
                this.hourTouchData.isMove = true;

                let loop = () => {
                    setTimeout(() => {
                        let pos = this.hourTouchData.positions.shift();
                        if (pos != undefined) {
                            if (pos.time - this.hourTouchData.start.time >= 30) {
                                let diff = pos.position - this.hourTouchData.start.position;
                                if (Math.abs(diff) > 5) {
                                    let h = 1;
                                    if (diff > 0) {
                                        h = -1;
                                    }

                                    let ch = this._hour;
                                    if (ch + h < 0) {
                                        ch = 23;
                                    }
                                    else if (ch + h > 23) {
                                        ch = 0;
                                    }
                                    else {
                                        ch += h;
                                    }

                                    this._hour = ch;
                                    this._time = this._hour + ':' + this._minute;
                                    //this._emitChangeEvent();
                                    
                                    this.hourTouchData.start.position = pos.position;
                                    this.hourTouchData.start.time = pos.time;
                                }
                            }
                            
                            loop();
                        }
                        else {
                            this.hourTouchData.isMove = false;
                        }
                    }, 30);
                }
                loop();
            }
        }

        event.preventDefault();
    }
    hourTouchEnd(event) {
        if (this.hourTouchData.isStart == true) {
            this.hourTouchData.isStart = false;
            this.hourTouchData.start.position = -1;
            this.hourTouchData.start.time = null;
        }
    }
}
  


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/components/datepicker/clock.ts